<template>
  <b-card no-body>
    <b-card-body v-if="$can('read', 'GUIDES_ADD')">
      <div class="text-right">
        <b-button
          variant="primary"
          to="/app/guides/add"
        >
          <FeatherIcon icon="PlusIcon" />
          {{ $t('common.create') }}
        </b-button>
      </div>
    </b-card-body>
    <guides-table />
  </b-card>
</template>

<script>
import { BCard, BCardBody, BButton } from 'bootstrap-vue'
import GuidesTable from './Components/GuidesTable.vue'

export default {
  name: 'Index',
  components: {
    BCard, BCardBody, BButton, GuidesTable,
  },
}
</script>
